module.exports = __webpack_public_path__ + "static/img/v2.9d76c10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/v2.png
// module id = BjEY
// module chunks = 1